export default {"src":"/_next/static/media/filter-icon.3f4cf187.svg","height":16,"width":23,"blurWidth":0,"blurHeight":0};